import React, { useEffect } from "react";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import GetAppIcon from "@mui/icons-material/GetApp";
import Modal from "@mui/material/Modal";

import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";

import FreeList from "./freeList";

import Grid from "@mui/material/Grid";
import Commands from "./commands";
import { SMTs } from "./SMTList";
import { parseCCH } from "./parseCCH";

function Body() {
  const [open, setOpen] = React.useState(false);

  const [warrant, setWarrant] = useState("");
  const [modalText, setModalText] = useState("");
  const [modalPlaceHolder, setModalPlaceHolder] = useState("");
  const [modalSource, setModalSource] = useState("");
  const [cch, setCCH] = useState("");

  const handleOpen = (source) => {
    if (source === "warrant") {
      setModalPlaceHolder("Paste Warrant Here");
      setModalSource("warrant");
      setModalText(warrant); // populate modal with current warrant
      setOpen(true);
    } else if (source === "cch") {
      setModalPlaceHolder("Paste CCH Here");
      setModalSource("cch");
      setModalText(cch); // populate modal with current cch
      setOpen(true);
    }
  };

  const handleClose = () => setOpen(false);

  const [AKAs, setListofAkas] = React.useState([]);
  const [SOCs, setListofSocs] = React.useState([]);
  const [DOBs, setListofDobs] = React.useState([]);
  const [SIDs, setListofSids] = React.useState([]);
  const [ScarsMarksTattoos, setListofSmtsToUse] = React.useState([]);
  const [CMCs, setListofCMCs] = React.useState([]);
  const [lidValue, setLidValue] = useState("");
  const [ocaValue, setOCAValue] = useState("");

  const handleParse = () => {
    const text = modalText.trim();
    if (modalSource === "warrant") {
      setWarrant(modalText);
      const lidMatch = text.match(/LID\/(\d+)/);
      const ocaMatch = text.match(/OCA\/(\S+)/);

      if (lidMatch) {
        setLidValue(lidMatch[1]);
      }
      if (ocaMatch) {
        setOCAValue(ocaMatch[1]);
      }
      handleClose();
    } else if (modalSource === "cch") {
      setCCH(text);
      addInfo(parseCCH(text, SMTs));
    }
    setOpen(false);
  };

  function addInfo(parsedInfo) {
    //dobs: dobs,
    //   socs: socs,
    //   smts: smts,
    //   sids: sids,

    let dobs = parsedInfo.dobs || [];
   
    if (dobs.length > 0) {
      dobs.forEach((dob) => {
        if (!DOBs.includes(dob) && !warrant.includes(`DOB/${dob}`)) {
          setListofDobs((prevDobs) => [...prevDobs, dob]);
        }
      });
    }

    let socs = parsedInfo.socs || [];
  
    if (socs.length > 0) {
      socs.forEach((soc) => {
        if (!SOCs.includes(soc) && !warrant.includes('SOC/' + soc)) {
          setListofSocs((prevSocs) => [...prevSocs, soc]);
        }
      });
    }

    let smts = parsedInfo.smts || [];
  
    if (smts.length > 0) {
      smts.forEach((smt) => {
        if (!ScarsMarksTattoos.includes(smt) && !warrant.includes(`SMT/${smt}`)) {
          setListofSmtsToUse((prevSMTs) => [...prevSMTs, smt]);
        }
      });
    }

    let nams = parsedInfo.akas || [];
  
    if (nams.length > 0) {
      nams.forEach((name) => {
        if (!AKAs.includes(name) && !warrant.includes(name)) {
          setListofAkas((prevNames) => [...prevNames, name]);
        }
      });
    }

    let sids = parsedInfo.sids || [];
  
    if (sids.length > 0) {
      sids.forEach((sid) => {
        if (!SIDs.includes(sid) && !warrant.includes(`SID/${sid}`)) {
          setListofSids((prevSIDS) => [...prevSIDS, sid]);
        }
      });
    }
  }
  const [smts, setListofSmts] = React.useState([]);

  useEffect(() => {
    setListofSmts(SMTs.map((item) => item.Code));
  }, []);
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100vw",
          height: "100vh",
        }}
      >
        <Paper
          elevation={1}
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "25%",
            padding: 2,
          }}
        >
          <Stack spacing={2} sx={{ width: "100%" }}>
            <TextField
              multiline
              rows={15}
              sx={{ width: "100%" }}
              placeholder={modalPlaceHolder}
              variant="outlined"
              value={modalText}
              onChange={(e) => setModalText(e.target.value)}
            ></TextField>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button variant="contained" color="error" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" color="success" onClick={handleParse}>
                Import
              </Button>
            </div>
          </Stack>
        </Paper>
      </Modal>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Import Documents
      </Typography>
      <Stack
        direction="row"
        spacing={2}
        // justifyContent="center"
        alignItems="flex-start"
        sx={{ mt: 2 }}
      >
        {/* <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
          Import Entered Warrant
        </Typography> */}
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 2 }}
          startIcon={<GetAppIcon />}
          onClick={() => handleOpen("warrant")}
        >
          Import Warrant
        </Button>

        <Button
          variant="contained"
          color="secondary"
          sx={{ mt: 2 }}
          startIcon={<GetAppIcon />}
          onClick={() => handleOpen("cch")}
        >
          Import CCH
        </Button>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <Typography variant="body1" sx={{ mb: 1 }}>
        Base Record Identifer Information
      </Typography>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
        <TextField
          label="LID"
          variant="outlined"
          size="small"
          sx={{ width: "10%", mb: 2 }}
          value={lidValue}
          onChange={(e) => setLidValue(e.target.value)}
        />
        <TextField
          label="OCA"
          variant="outlined"
          size="small"
          sx={{ width: "20%", mb: 2 }}
          value={ocaValue}
          onChange={(e) => setOCAValue(e.target.value)}
        />
      </div>
      <Divider sx={{ my: 2 }} />
      <Typography variant="body1" sx={{ mb: 1 }}>
        Supplemental Information
      </Typography>
      <Grid container spacing={2} width={"100%"}>
        <Grid size={6}>
          <FreeList
            single={"AKA"}
            plural={"AKAs"}
            min={3}
            max={30}
            list={setListofAkas}
            warrant={warrant}
            otherList={AKAs}
          />
        </Grid>
        <Grid size={6}>
          <FreeList
            single={"SOC"}
            plural={"SOCs"}
            min={9}
            max={9}
            list={setListofSocs}
            warrant={warrant}
            otherList={SOCs}
          />
        </Grid>
        <Grid size={6}>
          <FreeList
            single={"DOB"}
            plural={"DOBs"}
            min={8}
            max={8}
            list={setListofDobs}
            warrant={warrant}
            otherList={DOBs}
          />
        </Grid>
        <Grid size={6}>
          <FreeList
            single={"SID"}
            plural={"SIDs"}
            min={3}
            max={10}
            list={setListofSids}
            warrant={warrant}
            otherList={SIDs}
          />
        </Grid>
        <Grid size={6}>
          <FreeList
            single={"SMT"}
            plural={"SMTs"}
            min={3}
            max={10}
            list={setListofSmtsToUse}
            warrant={warrant}
            options={smts}
            otherList={ScarsMarksTattoos}
          />
        </Grid>
        <Grid size={6}>
          <FreeList
            single={"CMC"}
            plural={"CMCs"}
            min={1}
            max={100}
            list={setListofCMCs}
            warrant={warrant}
            options={[
              "00 - ARMED AND DANGEROUS",
              "01 - OTHER",
              "05 - VIOLENT TENDENCIES",
              "10 - MARTIAL ARTS EXPERT",
              "15 - EXPLOSIVE EXPERTISE",
              "20 - KNOWN TO ABUSE DRUGS",
              "25 - ESCAPE RISK",
              "30 - SEXUALLY VIOLENT PREDATOR",
              "35 - SEX OFFENDER",
              "40 - INTERNATIONAL FLIGHT RISK",
              "50 - HEART CONDITION",
              "55 - ALCOHOLIC",
              "60 - ALLERGIES",
              "65 - EPILEPSY",
              "70 - SUICIDAL",
              "80 - MEDICATION REQUIRED",
              "85 - HEMOPHILIAC",
              "90 - DIABETIC",
            ]}
            otherList={CMCs} // Replace spaces with underscores for CMCs
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }} />
      <Typography variant="body1" sx={{ mb: 1 }}>
        Command Line Commands
      </Typography>
      <Commands
        oca={ocaValue}
        lid={lidValue}
        akas={AKAs}
        dobs={DOBs}
        socs={SOCs}
        sids={SIDs}
        smts={ScarsMarksTattoos}
        cmcs={CMCs}
      />
    </>
  );
}

export default Body;
